import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgClock = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 16 16",
	fill: "currentColor",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		className: "hands",
		d: "M7.2 4h1.2v4.2l3.6 2.1-.6 1-4.2-2.5V4z"
	}), /* @__PURE__ */ _jsx("path", {
		className: "circle",
		d: "M8 0a8 8 0 100 16A8 8 0 008 0zm0 14.4A6.4 6.4 0 118 1.6a6.4 6.4 0 010 12.8z"
	})]
});
export default SvgClock;
